import { Observable, Subject, BehaviorSubject, of } from 'rxjs';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Router } from '@angular/router';

import { SuppliersListProperties, SuppliersProperties, SupplierData } from '../Models/SuppliersProperties';

import { SuppliersService } from '../Services/suppliers.service';
import { NgForm } from '@angular/forms';
import { Component } from '@angular/core';
import { User } from 'oidc-client';
import { OnChange } from 'ngx-bootstrap/utils';
declare var $;


@Component({
    selector: 'app-suppliers-list',
    templateUrl: './suppliers-list.component.html',
    styleUrls: ['./suppliers-list.component.css']
})
/** SuppliersList component*/
export class SuppliersListComponent {
 
  obj = new SuppliersListProperties();
  supplier = new SuppliersProperties();
  can: boolean = false;
 
  
  constructor(private service: SuppliersService, private router: Router) {
    this.onClickEditSupplierAir = this.onClickEditSupplierAir.bind(this);
    this.onClickEditSupplierVisa = this.onClickEditSupplierVisa.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
  }


  ngOnInit() {

    try {
      this.loadActiveSupplierTypes();

    } catch (ex) { }
  }
  loadActiveSupplierTypes() {
    try {
      this.service.getSuppliersList().subscribe((data: SuppliersListProperties) => {
        this.obj = data;
        this.service.CheckSupplierManagementRight(localStorage.getItem("UserId")).subscribe((data2) => {
          if (data2) {
            this.can = true;
          }
          
          if (!this.can) {
            for (let i = 0; i < this.obj.airSupplier.length; i++) {

              $("#airStatus").setAttribute('disabled', true);
            }
            for (let i = 0; i < this.obj.otherSupplier.length; i++) {
              $("#visaStatus").setAttribute('disabled', true);
            }
          }
       });
      });
      
    } catch (ex) {  }
  }

  onClickEditSupplierAir(e) {
   
    localStorage.setItem("ActionType", "AirOfficeEdit");
   
    localStorage.setItem("SupplierAccessCodeId", e.row.data.accessCodeId);
    if (this.can)
      this.router.navigateByUrl('/suppliersAddEdit');
  }

  AddNewAirSupplier() {
    
    localStorage.setItem("ActionType", "AirSupplierAdd");
    if (this.can)
     this.router.navigateByUrl('/suppliersAddEdit');
  }

  AddNewInsuranceSupplier() {
    
    localStorage.setItem("ActionType", "InsuranceSupplierAdd");
    if (this.can)
     this.router.navigateByUrl('/suppliersAddEdit');
  }

  AddNewAirOffice(id: string) {

    localStorage.setItem('ActionType', 'AirSupplierEdit');
    localStorage.setItem('SupplierId', id);
    if (this.can)
     this.router.navigateByUrl('/suppliersAddEdit');
  }

  EditInsuranceOffice(id: string) {
    localStorage.setItem('ActionType', 'InsuranceSupplierEdit');
    localStorage.setItem('SupplierId', id);
    if (this.can)
     this.router.navigateByUrl('/suppliersAddEdit');
  }

  onClickEditSupplierVisa(e) {
   

    localStorage.setItem("ActionType", "VisaOfficeEdit");
 
    localStorage.setItem("SupplierAccessCodeId", e.row.data.accessCodeId);
    if (this.can)
      this.router.navigateByUrl('/suppliersAddEdit');

  }
  AddNewVisaSupplier() {

    localStorage.setItem("ActionType", "VisaSupplierAdd");
    if (this.can)
      this.router.navigateByUrl('/suppliersAddEdit');


  }
  
  AddNewVisaOffice(id ) {


    localStorage.setItem("ActionType", "VisaOfficeAdd");
    localStorage.setItem('SupplierId', id);
    if (this.can)
     this.router.navigateByUrl('/suppliersAddEdit');
  }
  changeStatus(x, e) {
    
    try {
      //console.log(x,e.target.id);
      if (this.can) {
        let id = e.target.id;
        if (id == "airStatus") {
          this.supplier.supplierId = this.obj.airSupplier[x].supplierId;


         // for (let i = 0; i < this.obj.airSupplier.length; i++) {
          this.supplier.status = this.obj.airSupplier[x].supplierStatus;
          this.supplier.name = this.obj.airSupplier[x].supplierName;
          this.supplier.supplierId = this.obj.airSupplier[x].supplierId;
          this.supplier.supplierTypeId = this.obj.airSupplier[x].supplierTypeId;
          this.supplier.providerCode = this.obj.airSupplier[x].providerCode;
            this.supplier.modifyUser = Number(localStorage.getItem('UserId'));
            this.supplier.accessCodeList = [];
            this.service.updateStatus(this.supplier).subscribe((data) => {
              this.service.getSuppliersList().subscribe((data2) => {
                this.obj = data2
                if (this.can) {
                  

                  for (let j = 0; j < data2.airSupplier.length; j++) {
                    $("#airStatus").removeAttr("disabled");
                   // $("#airStatus").attr("disabled", false);
                    //document.getElementById('airStatus').disabled = true;
                   
                    
                  }
                 // for (let j = 0; j < this.obj.otherSupplier.length; j++) {

                   // //console.log(e.target.disabled);
                   // $("#visaStatus").removeAttr("disabled", "disabled");

                  //}
                }
                else {
                  $("#visaStatus").attr("disabled", "disabled");
                  $("#airStatus").attr("disabled", "disabled");
                }

              });

            });
          //}
        }
        else if (id == "visaStatus") {
          this.supplier.supplierId = this.obj.otherSupplier[x].supplierId;


         // for (let i = 0; i < this.obj.otherSupplier.length; i++) {
            this.supplier.status = this.obj.otherSupplier[x].supplierStatus;
            this.supplier.name = this.obj.otherSupplier[x].supplierName;
            this.supplier.supplierId = this.obj.otherSupplier[x].supplierId;
            this.supplier.supplierTypeId = this.obj.otherSupplier[x].supplierTypeId;
          this.supplier.providerCode = this.obj.otherSupplier[x].providerCode;
            this.supplier.modifyUser = Number(localStorage.getItem('UserId'));
            this.supplier.accessCodeList = [];
            this.service.updateStatus(this.supplier).subscribe((data) => {
              this.service.getSuppliersList().subscribe((data2) => {
                this.obj = data2
                
              });

            });
          }
        //}
      }
    } catch (ex) {
      //console.log(ex);
    }
    
  }
 
  
}
